import React from "react";

export function ErrorPage() {
    return(
        <div id="ErrorContainer">
            <h1 id="ErrorHeader">404</h1>
        </div>
    );
}